/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-div[_ngcontent-%COMP%]{margin:0 auto;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}.mat-table-no-border[_ngcontent-%COMP%]{border-collapse:collapse}.mat-table-no-border[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border:none;padding:8px}.table-container[_ngcontent-%COMP%]{width:80%}.text-main[_ngcontent-%COMP%]{text-align:center;color:#000;font-weight:700}"];
export { styles as styles };
